import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
// import { Resizable } from 'react-resizable';
import { getBoundingClientRect } from '../utils/functions';
import FixedView from './FixedView';
import StickersView from './views/messenger/StickersView';
class RichTextEditor extends Component {
    state = {
        content: '',
        bold: false,
        italic: false,
        underline: false,
    }

    onStickerSelect = (type, prop) => {
        if (type == 'emoji') {
            let input = this.editorRef
            let emoji = this.insertAtCursor(input, prop.emoji)
            this.editorRef.appendChild(emoji);
        }
    }

    insertAtCursor(myField, myValue) {
        let content = this.state.content
        myField.focus();
        if (document.selection) {
            let sel = document.selection.createRange();
        }
        else if (myField.selectionStart || myField.selectionStart == '0') {
            var startPos = myField.selectionStart;
            var endPos = myField.selectionEnd;
            content = myField.value.substring(0, startPos)
                + myValue
                + myField.value.substring(endPos, myField.value.length);
        } else {
            content += myValue;
        }
        this.setState({ content }, () => {
            myField.selectionStart = startPos + myValue.length
            myField.selectionEnd = startPos + myValue.length
        })
    }

    handleInput = (event) => {
        this.setState({ content: event.target.innerHTML });
    };

    handleKeyDown = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            document.execCommand('insertHTML', false, '&#009');
        }
    };

    handleBoldClick = () => {
        let bold = this.state.bold
        let selection = document.getSelection()
        let anchorOffset = selection.anchorOffset
        let focusOffset = selection.focusOffset
        if (selection.isCollapsed) {
            this.setState({ bold: !bold })
        }

        document.execCommand('bold', false, null);
    };

    handleItalicClick = () => {
        let italic = this.state.italic
        let selection = document.getSelection()
        let anchorOffset = selection.anchorOffset
        let focusOffset = selection.focusOffset
        if (selection.isCollapsed) {
            this.setState({ italic: !italic })
        }
        document.execCommand('italic', false, null);
    };

    handleUnderlineClick = () => {
        let underline = this.state.underline
        let selection = document.getSelection()
        let anchorOffset = selection.anchorOffset
        let focusOffset = selection.focusOffset
        if (selection.isCollapsed) {
            this.setState({ underline: !underline })
        }
        document.execCommand('underline', false, null);
    };

    handleImageUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = document.createElement('img');
            img.src = event.target.result;
            img.style.width = '100%'
            // const resizableImg = (
            //     <Resizable
            //         defaultSize={{ width: 200, height: 200 }}
            //         style={{ display: 'inline-block', padding: '5px' }}
            //     >
            //         {img}
            //     </Resizable>
            // );
            // this.editorRef.appendChild(resizableImg);
            this.editorRef.appendChild(img);
        };
        reader.readAsDataURL(file);
    };

    handleTableClick = () => {
        const rows = prompt('Enter number of rows:');
        const cols = prompt('Enter number of columns:');
        if (rows && cols) {
            const table = document.createElement('table');
            table.style.border = '0px'
            for (let i = 0; i < rows; i++) {
                const row = document.createElement('tr');
                for (let j = 0; j < cols; j++) {
                    const cell = document.createElement('td');
                    cell.style.border = '1px solid black';
                    cell.style.padding = '5px';
                    cell.style.minWidth = '50px';
                    cell.style.height = '50px';
                    row.appendChild(cell);
                }
                table.appendChild(row);
            }
            const tableWrapper = document.createElement('div');
            tableWrapper.style.width = '300px'
            tableWrapper.appendChild(table);
            this.editorRef.appendChild(tableWrapper);
        }
    };

    render() {
        const { bold, italic, underline } = this.state
        return (
            <div className='w-100 h-100 scroll-no-scrollbar'>
                <div className='flexc'>
                    <button className={bold ? 'textEditor flexcc br-8 mx-1' : 'flexcc br-8 mx-1'} onClick={() => this.handleBoldClick()}>
                        <img src='/assets/icons/bold.svg' />
                    </button>
                    <button className={italic ? 'textEditor flexcc br-8 mx-1' : 'flexcc br-8 mx-1'} onClick={() => this.handleItalicClick()}>
                        <img src='/assets/icons/italic.svg' />
                    </button>
                    <button className={underline ? 'textEditor flexcc br-8 mx-1' : 'flexcc br-8 mx-1'} onClick={() => this.handleUnderlineClick()}>
                        <img src='/assets/icons/underline.svg' />
                    </button>
                    <button >
                        <StickersView onSelect={this.onStickerSelect} />
                    </button>
                    <label className='mx-1 flexcc' ref={(el) => (this.currentNode = el)} onClick={() => this.fixedView.showView()}>
                        <img src='/assets/icons/image.svg' />
                        {/* <input type="file" accept="image/*" onChange={this.handleImageUpload} style={{ display: 'none' }} /> */}
                    </label>

                    <button className='flexcc mx-1' onClick={() => this.handleTableClick()}>
                        <img src='/assets/icons/table-black.svg' />
                    </button>
                </div>
                <div
                    ref={e => this.editorRef = e}
                    contentEditable={true}
                    onInput={e => this.handleInput(e.target)}
                    onKeyDown={e => this.handleKeyDown(e.target)}
                    value={this.state.content}
                    style={{ border: '1px solid #eee', padding: '10px' }}
                />
                <p>{this.state.content}</p>
                <FixedView ref={(el) => (this.fixedView = el)} nodeRef={this.currentNode} width={180} xOffset={0} topOffset={0} showFocus={false} zIndex={100}>
                    <div className='shadow-2 p-1 br-10' style={{}}>
                        <div className=" flexcc py-1 bb-gray flex-column" style={{ alignItems: "flex-start" }}>
                            <label className="flexc cursor-pointer w-100">
                                <div className="flexcb hover-fields-item w-100 p-1" style={{}}>
                                    <p className="text-smaller" style={{ color: '#777' }}>Upload Image</p>

                                    <img src='/assets/icons/image.svg' />
                                    <input type="file" accept="image/*" onChange={this.handleImageUpload} style={{ display: 'none' }} />
                                </div>
                            </label>

                            {/* <button className="flexc cursor-pointer w-100">
                                <div className="flexcb hover-fields-item w-100 p-1" style={{}}>
                                    <p className="text-smaller" style={{ color: '#777' }}>Upload Image</p>
                                </div>
                            </button> */}
                        </div>
                    </div>



                </FixedView>
            </div>
        );
    }
}

export default RichTextEditor;